//@ts-check
import SmrClient from "Utils/Requests/SmrClient";

class UtilityRequests {
    /**
     * @param {string} taskId
     */
    DownloadPreparedFile(taskId) {
        SmrClient.Download({
            url: 'Utility/PreparedFile',
            method: 'GET',
            body: { taskId }
        });
    }

    /**
     * @param {string} taskId
     * @returns {Promise<PrepareDownloadFileTask | null>}
     */
    CancelPreparedFile(taskId) {
        return SmrClient.FetchJson({
            url: 'Utility/CancelPreparedFile',
            method: "GET",
            body: { taskId }
        });
    }
}

export default new UtilityRequests;